var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetButtonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 17.6583L9.24167 18.4166C8.15 19.0916 6.63333 18.3333 6.63333 16.9833V12.525C6.63333 11.9333 6.3 11.175 5.95833 10.7583L2.75833 7.3916C2.33333 6.9666 2 6.21664 2 5.7083V3.77496C2 2.76663 2.75833 2.0083 3.68333 2.0083H14.8C15.725 2.0083 16.4833 2.76665 16.4833 3.69165V5.54163C16.4833 6.21663 16.0583 7.0583 15.6417 7.47497",
    stroke: "#2962FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2666 12.6248C17.2666 13.3665 17.0583 14.0665 16.6916 14.6665C16.0083 15.8165 14.75 16.5832 13.3083 16.5832C11.8666 16.5832 10.6083 15.8082 9.92498 14.6665C9.55831 14.0748 9.34998 13.3665 9.34998 12.6248C9.34998 10.4415 11.125 8.6665 13.3083 8.6665C15.4916 8.6665 17.2666 10.4415 17.2666 12.6248Z",
    stroke: "#2962FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3668 13.6583L12.2751 11.5667",
    stroke: "#2962FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3501 11.5916L12.2584 13.6832",
    stroke: "#2962FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4833 3.68335V5.53333C16.4833 6.20833 16.0583 7.05001 15.6417 7.47501L14.175 8.76666C13.9 8.7 13.6083 8.66667 13.3083 8.66667C11.125 8.66667 9.35 10.4417 9.35 12.625C9.35 13.3667 9.55833 14.0667 9.925 14.6667C10.2333 15.1833 10.6583 15.625 11.175 15.9417V16.225C11.175 16.7333 10.8417 17.4083 10.4167 17.6583L9.24167 18.4167C8.15 19.0917 6.63333 18.3333 6.63333 16.9833V12.525C6.63333 11.9333 6.29167 11.175 5.95833 10.7583L2.75833 7.39164C2.34167 6.96664 2 6.20834 2 5.70834V3.76666C2 2.75833 2.75833 2 3.68333 2H14.8C15.725 2 16.4833 2.75835 16.4833 3.68335Z",
    stroke: "#2962FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetButtonIcon);
export default __webpack_public_path__ + "static/media/reset-button-icon.b66b189b5574a45b597d3ba44e6a2520.svg";
export { ForwardRef as ReactComponent };